module.exports = __webpack_public_path__ + "img/republish.b8f0fef0.svg";